import React, { useState, useEffect } from 'react';
import './index.scss';
import { connect } from 'react-redux';
import closeIcon from '../../../../../asset/Arrow-Left_Med_808080.svg';
import { userHasPro } from '../../../../lib/util';
import { showHideSubscriptionModal } from '../../../../utils/subscriptionUtils';

const PropertiesDetails = (props) => {
  const [isCarouselOpen, setIsCarouselOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = props.PropertiesDetails?.Images || [];
  const hasPro = userHasPro(props.user)

  // Keyboard navigation
  useEffect(() => {
    if (!isCarouselOpen) return;

    const handleKeyDown = (event) => {
      if (event.key === 'ArrowRight') {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      } else if (event.key === 'ArrowLeft') {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
      } else if (event.key === 'Escape') {
        setIsCarouselOpen(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isCarouselOpen, images.length]);

  return (
    <div className='pt-side-Drawer-model-container'
      style={{
        height: 'calc(-130px + 89vh)',
        top: 'calc(128px + 12vh)',
        width: '46.86vw'
      }}>
      <div className='pt-header-img'>
        <img className='pt-close-icon' style={{ top: '1%' }} src={closeIcon} onClick={props.closeProperties} alt="Close" />
      </div>

      <div className='pt-land-info-container' style={{ height: '75vh' }}>
        <div className='pt-image-container' style={{ width: '98%' }}>
          <div className='first-img-container'>
            <div style={{ width: '90%', height: '80%', borderRadius: '10px' }}>
              <img
                src={images[0]}
                alt="Land Preview"
                className='image-bubble-hover'
                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', cursor: 'pointer' }}
                onClick={() => { setIsCarouselOpen(true); setCurrentIndex(0); }}
              />
            </div>
          </div>

          <div className="second-img-container">
            <div className="list-img-container" style={{ padding: 2 }}>
              {images.slice(1, 4).map((url, index) => (
                <div
                  key={index}
                  style={{
                    width: '48%',
                    height: '40%',
                    borderRadius: '10px',
                    minWidth: '12rem',
                    maxWidth: '14rem',
                  }}
                >
                  <img
                    src={url}
                    alt={`Land Image ${index + 1}`}
                    className='image-bubble-hover'
                    style={{ width: '100%', height: '100%', objectFit: 'cover', cursor: 'pointer' }}
                    onClick={() => { setIsCarouselOpen(true); setCurrentIndex(index + 1); }}
                  />
                </div>
              ))}

              {images.length > 4 && (
                <div
                  style={{
                    width: '48%',
                    height: '40%',
                    borderRadius: '10px',
                    border: '1px solid grey',
                    position: 'relative',
                    backgroundImage: `url(${images[4]})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 'bold',
                    fontSize: '18px',
                    cursor: 'pointer',
                    minWidth: '12rem',
                    maxWidth: '14rem',
                  }}
                  onClick={() => { setIsCarouselOpen(true); setCurrentIndex(4); }}
                >
                  +{images.length - 4} more
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          className='pt-land-details-description'
          dangerouslySetInnerHTML={{ __html: props.PropertiesDetails.Description }}
        />

        <button className='pt-book-now-button' onClick={() => window.open(props.PropertiesDetails.Link, '_blank')}> Book Now </button>

        {hasPro ?
          <div className='promocode-container'>
            <p>Promo Code : <span style={{ color: 'rgb(88, 149, 0)' }}>{props.landDetails?.promoCode?.promoCode}</span></p>
            <p>{props.landDetails?.promoCode?.description}</p>
          </div>
          :
          <div className='promocode-container'>
            <p><span className='promocode-upgrade-button' onClick={() => { showHideSubscriptionModal(props.auth.token) }}>Upgrade </span> to get free Booking Fees</p>
          </div>

          // <button className='pt-book-now-button' onClick={() => { showHideSubscriptionModal(props.auth.token) }} > Upgrade </button>
          // <div>
          //   <button className='pt-book-now-button'
          //     onClick={() => { showHideSubscriptionModal(props.auth.token) }}
          //   >UPGRADE</button>
          // </div>
        }
      </div>

      {/* Carousel Modal */}
      {isCarouselOpen && (
        <div className="carousel-overlay" onClick={() => setIsCarouselOpen(false)}>
          <div className="carousel-content" onClick={(e) => e.stopPropagation()}>
            <p onClick={() => setIsCarouselOpen(false)} className="pt-close-btn">✕</p>

            <div className='carousel-navigation-pt'>
              <div className='carousel-navigation-pt-child'>
                {/* LEFT / PREVIOUS */}
                <div
                  className='pt-carousel-arrow'
                  onClick={() =>
                    setCurrentIndex((currentIndex - 1 + images.length) % images.length)
                  }
                >
                  ‹
                </div>

                {/* COUNTER */}
                <div>
                  <span className="carousel-counter">
                    {currentIndex + 1} / {images.length}
                  </span>
                </div>

                {/* RIGHT / NEXT */}
                <div
                  className='pt-carousel-arrow'
                  onClick={() =>
                    setCurrentIndex((currentIndex + 1) % images.length)
                  }
                >
                  ›
                </div>
              </div>
            </div>

            <img
              src={images[currentIndex]}
              alt={`Carousel Image ${currentIndex + 1}`}
              className="carousel-img"
            />
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  privateLandItems: state.privateLandItems,
  privateLandFilterValues: state.privateLandFilterValues,
  lantTrustPrivateLandDetails: state.lantTrustPrivateLandDetails,
  selectedPrivateLandPayload: state.selectedPrivateLandPayload,
  user: state.user,
  auth: state.auth
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PropertiesDetails);
